import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemResponseEntity } from '../../domain/entities/ItemResponseEntity'
import { ItemMiniModel } from './ItemMiniModel'

export class ItemResponseModel extends ItemResponseEntity {
  constructor(dataDto: ItemResponseEntity) {
    super()
    const itemMiniModel = dataDto.items?.map((item) => new ItemMiniModel(item))
    mapEntityProperties<ItemResponseEntity>(this, dataDto, {
      map: {
        items: itemMiniModel
      }
    })
  }
}
